export const browsingSession = {
  isReloaded: window.performance
    .getEntriesByType("navigation")
    .map((nav) => nav.type)
    .includes("reload")
};
